import React from 'react'

// Returns true when the viewport is at/below `breakpoint` (default 768px).
// Used for layout swaps that pure CSS can't do — the calendar grid and the
// AIScreen 3-pane layout. The hamburger drawer itself is CSS-driven.
export function useIsMobile(breakpoint = 768) {
  const query = `(max-width: ${breakpoint}px)`
  const [isMobile, setIsMobile] = React.useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches
  )
  React.useEffect(() => {
    const mql = window.matchMedia(query)
    const onChange = (e) => setIsMobile(e.matches)
    mql.addEventListener('change', onChange)
    setIsMobile(mql.matches)
    return () => mql.removeEventListener('change', onChange)
  }, [query])
  return isMobile
}
